import { ChangeDetectionStrategy, Component, forwardRef, HostBinding, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'mtg-radio-group',
  templateUrl: './radio-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupComponent),
      multi: true
    }
  ],
})
export class RadioGroupComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private onTouch: () => void;
  private onChange: (value) => void;
  private control: AbstractControl;
  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  reverse: boolean;
  value: any;
  value$ = new Subject();
  @HostBinding('class.radio-group')
  defaultClass = true;

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    } else {
      this.control = this.formControl;
    }
  }

  ngOnDestroy(): void {
    this.value$.complete();
  }

  writeValue(obj: any): void {
    this.value = obj;
    this.value$.next(obj);
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  onItemClick(value: any): void {
    this.value = value;
    this.value$.next(value);
    if (this.onTouch) {
      this.onTouch();
    }
    if (this.onChange) {
      this.onChange(this.value);
    }
  }
}
